export default "__VITE_ASSET__DmTC6C7t__"